const webSite = 'https://cwnuzkbm.028zk01.net/self-service-cwnu' // 正式环境ip
const mobileUrl = 'https://cwnuzkbmh5.028zk01.net'
export default {
  webSite,
  mobileUrl
}
